import { createSelector } from 'reselect';

import { selectSubscribedMsiVessels } from '../../user-management/appSelectors';
import { IValueVessel } from './valueTypes';
import { selectSelectionData } from '../search/searchSelectors';
import { RootState } from '../../core/store';

export const valueVesselListSelector = createSelector(
    [selectSubscribedMsiVessels, selectSelectionData],
    (subscribedMsiVessels, selectionData) => {
        const selectedImoNumbers = new Set(selectionData.selectedVesselsList.map(v => v.imoNumber));

        if (!subscribedMsiVessels || subscribedMsiVessels.length === 0 || selectedImoNumbers.size === 0) {
            return [] as IValueVessel[];
        }

        // Map the subscribed vessels to the IValueVessel format, filtering by selected IMO numbers
        return subscribedMsiVessels.filter(v => selectedImoNumbers.has(v.imoNumber)).map(v => (
            {
                imoNumber: v.imoNumber,
                name: v.vesselName,
                sectorId: v.sectorId,
                sectorName: v.sectorName,
                size: v.size,
                sizeUnit: v.sizeUnit,
                age: v.age,
                yearOfDelivery: v.yearOfDelivery,
                iceClass: v.iceClass,
                countryOfBuild: v.countryOfBuild,
                yardTier: v.yardTier,
                gear: v.gear,
                hatch: v.hatch,
                scrubberFitted: v.scrubberFitted,
                engine: v.engine,
                fuelSystem: v.sectorCode === 'LNG' ? v.propulsionSystem : v.fuelSystem ? v.fuelSystem : 'Conventional',
                owner: v.owner,
                gearTankCargoContainment: v.gear || v.tank || v.cargoContainment,
                efficiency: v.efficiency,
                quarterRampCapacity: v.quarterRampCapacity,
                hoistableDecks: v.hoistableDecks,
                tank: v.tank,
                imoClassAndCoating: v.imoClassAndCoating,
                pumpRoom: v.pumpRoom,
                dwtCapacity: v.dwtCapacity,
                reeferPlugs: v.reeferPlugs,
                homogeneousIntake: v.homogenousIntake,
                eco: v.eco,
                propulsionSystem: v.propulsionSystem,
                cargoContainment: v.cargoContainment,
                ammoniaCarrier: v.ammoniaCarrier === null ? "No" : v.ammoniaCarrier,
            })) as IValueVessel[];
    }
);

export const selectMsiValueData = createSelector([(state: RootState) => state.valueSlice], (valueSlice) => valueSlice.msiValueState || null);